import { CONTENT } from './Store/Actions'
import Screening from './Components/Pages/Screening';
import Assessment from './Components/Pages/Assessment';
import Results from './Components/Pages/Results';
import WelcomeScreen from './Components/Pages/Welcome';
import AssessmentId from './Components/Pages/AssessmentId';
import SchemaData from './Data/schema';

const pages = {
    home:{
        title:"welcome",
        slug:"",
        component:WelcomeScreen
    },
    welcome:{
        title:"welcome",
        slug:"welcome",
        component:WelcomeScreen
    },
    assessmentId:{
        title:"assessment id",
        slug:"assessment-id",
        component:AssessmentId
    },
    screening:{
        title:"screening",
        slug:"screening",
        component:Screening
    },
    assessment:{
        title:"assessment & mitigation actions",
        slug:"assessment",
        component:Assessment
    },
    results:{
        title:"results",
        slug:"results",
        component:Results
    }
}

let apiVersion = "1-0-2"
let appBaseURL = "https://cfsy06sabj.execute-api.eu-west-1.amazonaws.com/"+process.env.REACT_APP_CONTENT_ENVIROMENT+"-"+apiVersion+"/"
let appExportBaseURL = "https://wsi86ltaxe.execute-api.eu-west-1.amazonaws.com/"+process.env.REACT_APP_CONTENT_ENVIROMENT+"-"+SchemaData.version+"/"

const initialState = {
    hasShownFavouriteToolTip:false,
    apiBaseUrl:appBaseURL,
    appExportBaseURL:appExportBaseURL,
    schemaVersion:SchemaData.version,
    pages:{...pages},
    projectPages:[
        pages.home,
        pages.assessmentId,
        pages.screening,
        pages.assessment,
        pages.results
    ],
    projectNav:[
        pages.assessmentId,
        pages.screening,
        pages.assessment,
        pages.results
    ],
    schema:SchemaData,
    entry:{

    },
    connectionIssue:false,
    isInConflict:false,
}
function processEntry(project, schema) {
    
    let projectClone

    if(project === undefined){
        projectClone = {}
        projectClone.entries = {}
        projectClone.entries.assessmentID = {}
        projectClone.entries.assessment = {}
        projectClone.forBuild = process.env.REACT_APP_TAG_NAME
        projectClone.schemaVersion = SchemaData.version
        projectClone.lastUpdateTimestamp = new Date().getTime();
    }else{
        projectClone = JSON.parse(JSON.stringify(project))
        projectClone.entries = project.entries
    }

    return projectClone
}
// Use the initialState as a default value
export default function appReducer(state = initialState, action) {
    // The reducer normally looks at the action type field to decide what happens
    switch (action.type) {
        case CONTENT.PROJECT_CONTENT_RECIVED: {
            return {
                ...state,
                schema:state.schema,
                project:{
                    ...state.project,
                    ...processEntry(action.payload.project,action.payload.schema)
                },
                connectionIssue:false
            }
        }
        case CONTENT.FAVOURITE_TOOL_TIP_SHOWN: {
            return {
                ...state,
                hasShownFavouriteToolTip:action.payload
            }
        }
        case CONTENT.CONNECTION_ISSUES: {
            return {
                ...state,
                connectionIssue:action.payload
            }
        }
        case CONTENT.IS_IN_CONFLICT: {
            return {
                ...state,
                isInConflict:action.payload
            }
        }
        case CONTENT.PROJECT_CONTENT_SAVED: {
            return {
                ...state,
                project:{
                    ...action.payload
                },
                connectionIssue:false
            }
        }
        case CONTENT.PROJECT_ID_DEFINED: {
            return {
              ...state,
              project:{
                    ...state.project, 
                    projectId:action.payload
                }
            }
        }
        default:
            // If this reducer doesn't recognize the action type, or doesn't
            // care about this specific action, return the existing state unchanged
            return state
    }
}